import React from 'react'
import { theme } from 'antd'
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis } from 'recharts'
import type { DataKey } from 'recharts/types/util/types'
import { colorPrimary } from '../../branding'

type DailyBarChartProps<T extends { date: string }> = {
    data?: T[]
    dataKey: DataKey<T>
    label: string
    height?: number
}

// One series per chart: the overview shows small multiples so each series keeps its own scale.
export function DailyBarChart<T extends { date: string }>({
    data,
    dataKey,
    label,
    height = 160,
}: DailyBarChartProps<T>) {
    const { token } = theme.useToken()

    return (
        <div
            className="w-full"
            style={{ height }}
        >
            <ResponsiveContainer
                width="100%"
                height="100%"
            >
                <BarChart
                    data={data || []}
                    margin={{
                        left: 4,
                        right: 4,
                    }}
                >
                    <CartesianGrid vertical={false} />
                    <XAxis
                        dataKey="date"
                        tickLine={false}
                        axisLine={false}
                        tickMargin={8}
                        minTickGap={32}
                        tickFormatter={(value: string) => {
                            const date = new Date(value)

                            return date.toLocaleDateString(undefined, {
                                month: 'short',
                                day: 'numeric',
                            })
                        }}
                    />
                    <Tooltip
                        cursor={{ fill: token.colorFillTertiary }}
                        formatter={(value) => [value, label]}
                        labelFormatter={(value) => {
                            return new Date(String(value)).toLocaleDateString(undefined, {
                                weekday: 'long',
                                month: 'short',
                                day: 'numeric',
                                year: 'numeric',
                            })
                        }}
                    />
                    <Bar
                        dataKey={dataKey}
                        fill={colorPrimary}
                        radius={[token.borderRadiusSM, token.borderRadiusSM, 0, 0]}
                    />
                </BarChart>
            </ResponsiveContainer>
        </div>
    )
}
